import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useEffect } from 'react';
import { getLoginUrl } from '@/queries/auth';
import { ToastContainer } from '../components/Toasts';

export const Route = createRootRoute({
    component: RootComponent,
    // TODO: Implement failsafe error boundary
    errorComponent: () => {
        return (
            <div>
                <p>Something went wrong</p>
            </div>
        );
    },
    // Only reached for a path outside both the `/system` and `/_client` subtrees
    // entirely (e.g. a dev-only route like `/sandbox/*` with no catch-all of its
    // own) — there's no app shell to render a message inside of, so just send the
    // visitor to the client login page. Both subtrees have their own splat route
    // (`system/_auth/$.tsx` / `_client/_auth/$.tsx`) that handles an unmatched path
    // *within* them, rendered inside that subtree's shell.
    notFoundComponent: NotFoundRedirect,
});

function NotFoundRedirect() {
    useEffect(() => {
        window.location.href = getLoginUrl('client');
    }, []);
    return null;
}

function RootComponent() {
    return (
        <>
            <Outlet />
            <TanStackRouterDevtools position="bottom-right" />
            <ToastContainer />
        </>
    );
}
